let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8ghg4")).then(() => parcelRequire('6J7pq'));